import {
  ACTIVATE_PUBLISHED_JOB,
  ALL_JOBS_COUNT,
  AUTOCOMPLETE_JOB_SEARCH,
  DELETE_JOB_SOFTLY,
  FETCH_MATCHING_CANDIDATES,
  GET_FAVORITE_CANDIDATES,
  INIT_RECRUITER,
  INTERVIEW_LISTING,
  JOBS_POSTED_BY_RECRUITER,
  JOBS_POSTED_BY_RECRUITER_LOADING,
  MATCHING_CANDIDATES,
  MEMBERS_JOBS_STATISTICS,
  POKE_CANDIDATE,
  POKE_CANDIDATE_LOADING,
  POST_JOB,
  POST_JOB_LIMIT_ERROR,
  RECRUITER_LOADING,
  REMOVE_TOP_JOBS_WITH_CANDIDATES,
  RESUME_CANDIDATE_INTERVIEW,
  SAVE_UPDATED_JOB_DESCRIPTION,
  START_CANDIDATE_INTERVIEW,
  TOP_JOBS_WITH_CANDIDATES,
  UPDATE_FAVORITE_CANDIDATE,
  UPDATE_JOB,
  UPDATE_MATCHING_CANDIDATES,
  UPDATE_TOP_MATCHING_CANDIDATES,
  UPDATE_INTERVIEW_STATUS,
  FETCH_INTERVIEW_HISTORY,
  IS_MATCHING_CANDIDATES_EXIST,
  ASSESSMENT_LISTING,
  ASSESSMENT_LISTING_FETCH_LOADING,
  ASSESSMENT_LISTING_DATA,
  JOB_LISTING_PAGINATION,
  JOB_LISTING_DATE_FILTER,
  JOB_LISTING_SEARCHED_JOB_FILTER,
  ZAPPYHIRE_JOB_POST,
  ZAPPYHIRE_CREATE_CANDIDATE,
  ZAPPYHIRE_SSO,
  APP_ENG_ASSESSMENT_LISTING,
  APP_ANNOTATION_ASSESSMENT_LISTING,
  RESET_ASSESSMENT,
  INCEPTION_STATS,
  UPDATE_COMPANY_SETTING,
  APP_ENG_ASSESSMENT_LISTING_V2,
  APP_ENG_ASSESSMENT_LISTING_V3,
  APP_ENG_ASSESSMENT_LISTING_V4,
  APP_ANNOTATION_ASSESSMENT_LISTING_V2,
  APP_ANNOTATION_ASSESSMENT_LISTING_V3,
  FETCH_OVERALL_ASSESSMENTS,
  UPDATE_APPROVAL_CRITERIA,
  FETCH_CANCELLED_ASSESSMENTS_CANDIDATES,
  RESET_CANCELLED_ASSESSMENT,
  REDO_ASSESSMENT_REQUEST,
  FETCH_REDO_ASSESSMENTS_CANDIDATES,
  GET_EMAIL_TEMPLATES,
  GET_EMAIL_TEMPLATE,
  UPDATE_EMAIL_TEMPLATE,
  APPROVE_ASSESSMENT_RESUME,
  REJECT_ASSESSMENT_RESUME,
  GET_SURVEY_QUESTIONS,
  UPDATE_SURVEY_QUESTION,
  ADD_SURVEY_QUESTION,
  SUBMIT_SURVEY_QUESTIONS,
  DASHBOARD_COUNTS,
  DELETE_SURVEY_QUESTION,
  FETCH_AI_ASSESSMENT_LISTING,
  FETCH_AI_ASSESSMENT_DETAILS,
  UPDATE_AI_ASSESSMENT,
  DELETE_AI_ASSESSMENT,
  FETCH_ASSESSMENT_STATS,
  FETCH_AI_ASSESSMENT_QUESTIONS,
  ADD_AI_ASSESSMENT_QUESTION,
  UPDATE_AI_ASSESSMENT_QUESTION,
  DELETE_AI_ASSESSMENT_QUESTION,
  CREATE_AI_ASSESSMENT_SESSION,
  CHAT_WITH_AI_ASSISTANT,
  UPDATE_ASSESSMENT_WITH_AI,
  SET_AI_SESSION,
  FETCH_AVAILABLE_APPLICANTS,
  SET_AVAILABLE_APPLICANTS,
  ASSIGN_ASSESSMENT_TO_APPLICANTS,
  FETCH_APPLICANT_ASSESSMENTS,
  SET_APPLICANT_ASSESSMENTS,
  FETCH_APPLICANT_ASSESSMENT_DETAILS,
  SET_APPLICANT_ASSESSMENT_DETAILS,
  APP_AI_ASSESSMENT_LISTING,
  FETCH_APP_AI_ASSESSMENT,
  CLEAR_AI_SESSION,
  RESET_AI_ASSESSMENT
} from "@/store/modules/recruiter/constants";
import {
  activate_published_job,
  fetch_assessment_listing,
  fetch_favorite_candidates,
  fetch_interview_history,
  fetch_interview_listing,
  fetch_members_jobs_stats,
  fetch_total_jobs_count,
  get_jobs_posted_by_recruiter,
  get_search_candidates,
  is_matching_candidates_exist,
  poke_candidate,
  post_job,
  resume_interview,
  save_updated_job_description,
  soft_delete_job,
  start_interview,
  update_favorite_candidate,
  update_interview_status,
  update_job,
  zappyhire_post_job,
  zappyhire_create_candidate,
  zappyhire_sso,
  fetch_app_assessment_listing,
  delete_assessment,
  inception_stats,
  update_company_setting,
  fetch_app_overall_result,
  update_approval_criteria,
  fetch_cancelled_assessment_candidates,
  reset_all_cancelled_assessment,
  redo_assessment_request,
  fetch_redo_assessment_candidates,
  get_email_templates,
  update_email_template,
  get_email_template,
  get_survey_questions,
  add_survey_question,
  update_survey_question,
  submit_survey_questions,
  dashboard_counts,
  delete_survey_question,
  fetch_ai_assessment_listing,
  fetch_ai_assessment_details,
  update_ai_assessment,
  fetch_assessment_stats,
  fetch_ai_assessment_questions,
  add_ai_assessment_question,
  update_ai_assessment_question,
  delete_ai_assessment_question,
  create_ai_assessment_session,
  chat_with_ai_assistant,
  update_assessment_with_ai,
  fetch_available_applicants,
  assign_assessment_to_applicant,
  fetch_applicant_assessments,
  fetch_applicant_assessment_details,
  fetch_app_ai_assessment_listing,
  fetch_app_ai_assessment,
  reset_ai_assessment,
  reset_assessment,
  approve_assessment_resume,
  reject_assessment_resume
} from "@/store/apis/recruiter";
import { Commit, Dispatch } from "vuex";
import { Jobs } from "@/interfaces/data_objects/jobs";
import {
  FetchAssessmentListingPayload,
  GetJobsPostedPayload,
  InterviewListing,
  InterviewListingPayload,
  // MatchingCandidatesByIdPayload,
  MembersJobsStatistics,
  PokeCandidatePayload,
  ResumeInterviewPayload,
  SaveUpdatedJobDescriptionPayload,
  SearchCandidatesAccumulator,
  SearchCandidatesPayload,
  SearchedCandidate,
  StartInterviewPayload,
  UpdateFavoriteCandidatePayload,
  UpdateInterviewStatusPayload,
  UpdateJobPayload,
  ZappyhireCreateCandidatePayload,
  ZapphirePostJobResponse,
  ZapphireCreateCandidateResponse,
  AppAssessmentListingPayload,
  AppEngAssessmentListing,
  UpdateCompanySettingPayload,
  AppOverAllAssessmentListing,
  UpdateApprovalCriteriaPayload,
  FetchCancelledAssessmentCandidatesPayload,
  CancelledAssessmentCandidates,
  DeleteCancelledAssessmentPayload,
  FetchRedoAssessmentCandidatesPayload,
  RedoAssessmentCandidates,
  UpdateEmailTemplatePayload,
  EmailTemplate,
  AddSurveyQuestionPayload,
  SubmitSurveyQuestionsPayload,
  FetchAssessmentAiListingPayload,
  AssessmentStats,
  FetchAssessmentAiQuestionsPayload,
  AssessmentQuestion,
  AppAiAssessmentListing,
  AssessmentAiListing,
  FetchAppAiAssessmentPayload,
  ResetAssessmentPayload
} from "@/store/modules/recruiter/interfaces";
import { Candidates } from "@/interfaces/data_objects/candidates";
import { ROOT_ERROR, ROOT_NOTIFICATION } from "@/store/modules/root/constants";
import { Interview } from "@/interfaces/responses/interviews/interviews";
import { ZappyhirePostjobPayload } from "@/interfaces/recruiter/jobs/post_job/zappyhire_post_job";
import { Company } from "../auth/interfaces";
import { AssessmentQuestions } from "@/interfaces/responses/assessment_questions";
export default {
  [POST_JOB]: async (
    { commit }: { commit: Commit },
    payload: FormData
  ): Promise<unknown | null> => {
    try {
      commit(RECRUITER_LOADING, true);
      const response = await post_job(payload);
      commit(RECRUITER_LOADING, false);
      commit(JOB_LISTING_SEARCHED_JOB_FILTER, null);
      commit(JOB_LISTING_DATE_FILTER, []);
      commit(JOB_LISTING_PAGINATION, 1);
      return response.data.data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      if (e.message.toString().includes("403")) {
        commit(
          POST_JOB_LIMIT_ERROR,
          "Limit Reached. Please contact at info@hcms.ai for more information"
        );
      }
      commit(RECRUITER_LOADING, false);
      return null;
    }
  },
  /**
   * Function to get jobs posted by recruiter
   * Jobs return in pagination
   * After getting jobs loop each job and fetch applicants separately
   * @param payload
   */
  [JOBS_POSTED_BY_RECRUITER]: async (
    { commit }: { commit: Commit },
    payload: GetJobsPostedPayload
  ): Promise<void> => {
    commit(JOBS_POSTED_BY_RECRUITER_LOADING, true);
    // await new Promise((resolve) => setTimeout(resolve, 3000));
    const response = await get_jobs_posted_by_recruiter(payload);
    let jobs = response?.data?.data || { results: [], total: 0 };
    jobs = {
      results: jobs.results.map((v: Jobs) => ({
        ...v,
        matching_candidates: [],
        candidates_loading: true
      })),
      total: jobs.total
    };
    if (payload.dashboard) commit(TOP_JOBS_WITH_CANDIDATES, jobs);
    else commit(JOBS_POSTED_BY_RECRUITER, jobs);
    commit(JOBS_POSTED_BY_RECRUITER_LOADING, false);
  },
  /**
   * Function to get matching candidates/applicants against job id
   */
  [MATCHING_CANDIDATES]: async (
    { commit }: { commit: Commit },
    payload: SearchCandidatesPayload
  ): Promise<void> => {
    try {
      const response = await get_search_candidates(payload);
      const response_data = response.data.data;
      const candidates_job_based: SearchCandidatesAccumulator =
        response_data.results.reduce(
          (
            accumulator: SearchCandidatesAccumulator,
            obj: SearchedCandidate
          ) => {
            const jobId = obj.job_id;
            if (!jobId) return accumulator;
            if (!accumulator[jobId]) {
              accumulator[jobId] = [];
            }
            accumulator[jobId].push(obj);
            return accumulator;
          },
          {}
        );
      if (payload.dashboard) {
        commit(UPDATE_TOP_MATCHING_CANDIDATES, {
          candidates_job_based
        });
      } else {
        commit(UPDATE_MATCHING_CANDIDATES, {
          candidates_job_based
        });
      }
    } catch (e) {
      if (!payload.job_ids) return;
      const candidates_job_based: SearchCandidatesAccumulator = {};
      for (const job of payload.job_ids) {
        candidates_job_based[job] = [];
      }
      if (payload.dashboard) {
        commit(UPDATE_TOP_MATCHING_CANDIDATES, {
          candidates_job_based
        });
      } else {
        commit(UPDATE_MATCHING_CANDIDATES, {
          candidates_job_based
        });
      }
    }
  },
  /**
   * Function to softly delete job
   * @param job_id:number => jid to remove
   */
  [DELETE_JOB_SOFTLY]: async (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    { commit, getters }: { commit: Commit; getters: any },
    job_id: number
  ): Promise<boolean> => {
    try {
      commit(RECRUITER_LOADING, true);
      await soft_delete_job({ job_id });
      // Checking if job exist in top jobs data set
      const top_posted_jobs = getters.TOP_JOBS_WITH_CANDIDATES;
      const exist_job = top_posted_jobs.results.find(
        (v: Jobs) => v.jid === job_id
      );
      // If job exist in top jobs data set => remove & decrement total count
      if (exist_job) {
        commit(REMOVE_TOP_JOBS_WITH_CANDIDATES, job_id);
      }
      // If job not exist in top jobs data set => decrement total count only
      else commit(REMOVE_TOP_JOBS_WITH_CANDIDATES, -100);
      commit(RECRUITER_LOADING, false);
      return true;
    } catch (e) {
      commit(RECRUITER_LOADING, false);
      return false;
    }
  },
  /**
   * Function to get matching candidates/applicants
   */
  [FETCH_MATCHING_CANDIDATES]: async (
    { commit }: { commit: Commit },
    payload: SearchCandidatesPayload
  ): Promise<Candidates.Candidates[] | null> => {
    try {
      const response = await get_search_candidates(payload);
      return response.data.data;
    } catch (e) {
      commit(ROOT_ERROR, null, { root: true });
      return null;
    }
  },
  /**
   * Function for autocomplete job search
   */
  [AUTOCOMPLETE_JOB_SEARCH]: async (
    { commit }: { commit: Commit },
    payload: GetJobsPostedPayload
  ): Promise<Jobs[]> => {
    try {
      const response = await get_jobs_posted_by_recruiter(payload);
      return response.data.data.results;
    } catch (e) {
      commit(ROOT_ERROR, null, { root: true });
      return [];
    }
  },
  /**
   * Initialize recruiter data
   */
  [INIT_RECRUITER]: async ({
    dispatch
  }: {
    dispatch: Dispatch;
  }): Promise<boolean> => {
    try {
      const fetch_top_candidates_obj = {
        page: 0,
        limit_per_page: 5,
        dashboard: true
      };
      await dispatch(JOBS_POSTED_BY_RECRUITER, fetch_top_candidates_obj);
      return true;
    } catch (e) {
      return false;
    }
  },
  /**
   * Action to activate published job
   */
  [ACTIVATE_PUBLISHED_JOB]: async (
    { commit }: { commit: Commit },
    job_id: number
  ): Promise<boolean> => {
    try {
      commit(RECRUITER_LOADING, true);
      await activate_published_job(job_id);
      commit(RECRUITER_LOADING, false);
      return true;
    } catch (e) {
      commit(RECRUITER_LOADING, false);
      return false;
    }
  },
  /**
   * Function to fetch all jobs count
   */
  [ALL_JOBS_COUNT]: async (): Promise<number> => {
    try {
      return (await fetch_total_jobs_count()).data.data;
    } catch (e) {
      return 0;
    }
  },
  /**
   * Function to update job
   */
  [UPDATE_JOB]: async (
    { commit }: { commit: Commit },
    payload: UpdateJobPayload
  ): Promise<boolean> => {
    try {
      commit(RECRUITER_LOADING, true);
      await update_job(payload);
      commit(RECRUITER_LOADING, false);
      return true;
    } catch (e) {
      commit(RECRUITER_LOADING, false);
      return false;
    }
  },
  [MEMBERS_JOBS_STATISTICS]: async (
    _: { commit: Commit },
    payload: MembersJobsStatistics
  ): Promise<unknown> => {
    try {
      const response = await fetch_members_jobs_stats(payload);
      return response.data.data;
    } catch (e) {
      return false;
    }
  },
  /**
   * For getting favorite candidates against job
   */
  [GET_FAVORITE_CANDIDATES]: async (
    _: { commit: Commit },
    job_id: number
  ): Promise<unknown> => {
    try {
      const response = await fetch_favorite_candidates(job_id);
      return response.data.data;
    } catch (e) {
      return [];
    }
  },
  /**
   * For updating favorite candidates against job
   */
  [UPDATE_FAVORITE_CANDIDATE]: async (
    _: { commit: Commit },
    payload: UpdateFavoriteCandidatePayload
  ): Promise<boolean> => {
    try {
      await update_favorite_candidate(payload);
      return true;
    } catch (e) {
      return false;
    }
  },
  /**
   * Action to poke candidate (send email to candidate)
   * @param commit
   * @param {PokeCandidatePayload} payload
   */
  [POKE_CANDIDATE]: async (
    { commit }: { commit: Commit },
    payload: PokeCandidatePayload
  ): Promise<void> => {
    try {
      commit(POKE_CANDIDATE_LOADING, true);
      const response = await poke_candidate(payload);
      commit(ROOT_NOTIFICATION, response.data.message, { root: true });
      commit(POKE_CANDIDATE_LOADING, false);
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      commit(POKE_CANDIDATE_LOADING, false);
    }
  },
  /**
   * Action to save updated job description during posting new job as custom
   * @param {SaveUpdatedJobDescriptionPayload} payload
   */
  [SAVE_UPDATED_JOB_DESCRIPTION]: async (
    { commit }: { commit: Commit },
    payload: SaveUpdatedJobDescriptionPayload
  ): Promise<void> => {
    try {
      commit(RECRUITER_LOADING, true);
      await save_updated_job_description(payload);
      commit(RECRUITER_LOADING, false);
    } catch (e) {
      commit(RECRUITER_LOADING, false);
    }
  },
  [START_CANDIDATE_INTERVIEW]: async (
    { commit }: { commit: Commit },
    payload: StartInterviewPayload
  ): Promise<unknown> => {
    try {
      const response = await start_interview(payload);
      return response.data.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return [];
    }
  },
  [RESUME_CANDIDATE_INTERVIEW]: async (
    _: { commit: Commit },
    payload: ResumeInterviewPayload
  ): Promise<null | string> => {
    try {
      const response = await resume_interview(payload);
      return response.data.data;
    } catch (e) {
      return null;
    }
  },
  [INTERVIEW_LISTING]: async (
    { commit }: { commit: Commit },
    payload: InterviewListingPayload
  ): Promise<null | InterviewListing> => {
    try {
      const response = await fetch_interview_listing(payload);
      return response.data.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [UPDATE_INTERVIEW_STATUS]: async (
    _: { commit: Commit },
    payload: UpdateInterviewStatusPayload
  ): Promise<null | boolean> => {
    try {
      const response = await update_interview_status(payload);
      return response.data.data;
    } catch (e) {
      return null;
    }
  },
  [FETCH_INTERVIEW_HISTORY]: async (
    _: { commit: Commit },
    payload: number
  ): Promise<Interview.InterviewHistoryResponse[]> => {
    try {
      const response = await fetch_interview_history(payload);
      return response.data.data;
    } catch (e) {
      return [];
    }
  },
  [IS_MATCHING_CANDIDATES_EXIST]: async (
    _: { commit: Commit },
    job_id: number
  ): Promise<boolean> => {
    try {
      const response = await is_matching_candidates_exist(job_id);
      return response.data.data.exist;
    } catch (e) {
      return false;
    }
  },
  [ASSESSMENT_LISTING]: async (
    { commit }: { commit: Commit },
    payload: FetchAssessmentListingPayload
  ): Promise<void> => {
    try {
      commit(ASSESSMENT_LISTING_FETCH_LOADING, true);
      const response = await fetch_assessment_listing(payload);
      commit(ASSESSMENT_LISTING_DATA, response.data.data);
      commit(ASSESSMENT_LISTING_FETCH_LOADING, false);
    } catch (e) {
      commit(ASSESSMENT_LISTING_FETCH_LOADING, false);
      commit(ROOT_ERROR, e, { root: true });
    }
  },
  [ZAPPYHIRE_JOB_POST]: async (
    _: { commit: Commit },
    payload: ZappyhirePostjobPayload
  ): Promise<ZapphirePostJobResponse | null> => {
    try {
      const response = await zappyhire_post_job(payload);
      return response.data.data;
    } catch (e) {
      return null;
    }
  },
  [ZAPPYHIRE_CREATE_CANDIDATE]: async (
    _: { commit: Commit },
    payload: ZappyhireCreateCandidatePayload
  ): Promise<ZapphireCreateCandidateResponse | null> => {
    try {
      const response = await zappyhire_create_candidate(
        payload.payload,
        payload.job_id,
        payload.candidate_id
      );
      return response.data.data;
    } catch (e) {
      return null;
    }
  },
  [ZAPPYHIRE_SSO]: async (): Promise<string | null> => {
    try {
      const response = await zappyhire_sso();
      return response.data.data.token;
    } catch (e) {
      return null;
    }
  },
  [APP_ENG_ASSESSMENT_LISTING]: async (
    { commit }: { commit: Commit },
    payload: AppAssessmentListingPayload
  ): Promise<boolean> => {
    console.log("Action: APP_ENG_ASSESSMENT_LISTING called", payload);
    try {
      const response = await fetch_app_assessment_listing(payload);
      const data: AppEngAssessmentListing = {
        limit: payload.limit,
        page: payload.page,
        total: response.data.data.total,
        results: response.data.data.results,
        selected_dates: payload.selected_dates,
        selected_candidates: payload.selected_candidates,
        score_filter: payload.score_filter,
        status_filter: payload.status_filter,
        sort_by: payload.sort_by,
        sort_order: payload.sort_order
      };
      if (payload?.version === "v1") commit(APP_ENG_ASSESSMENT_LISTING, data);
      else if (payload?.version === "v3")
        commit(APP_ENG_ASSESSMENT_LISTING_V3, data);
      else if (payload?.version === "v4")
        commit(APP_ENG_ASSESSMENT_LISTING_V4, data);
      else commit(APP_ENG_ASSESSMENT_LISTING_V2, data);
      return true;
    } catch (e) {
      return false;
    }
  },
  [APP_ANNOTATION_ASSESSMENT_LISTING]: async (
    { commit }: { commit: Commit },
    payload: AppAssessmentListingPayload
  ): Promise<boolean> => {
    try {
      const response = await fetch_app_assessment_listing(payload);
      const data: AppEngAssessmentListing = {
        limit: payload.limit,
        page: payload.page,
        total: response.data.data.total,
        results: response.data.data.results,
        selected_dates: payload.selected_dates,
        selected_candidates: payload.selected_candidates,
        score_filter: payload.score_filter,
        status_filter: payload.status_filter,
        sort_by: payload.sort_by,
        sort_order: payload.sort_order
      };
      if (payload.version && payload.version === "v1")
        commit(APP_ANNOTATION_ASSESSMENT_LISTING, data);
      else if (payload.version && payload.version === "v3")
        commit(APP_ANNOTATION_ASSESSMENT_LISTING_V3, data);
      else commit(APP_ANNOTATION_ASSESSMENT_LISTING_V2, data);
      return true;
    } catch (e) {
      return false;
    }
  },
  [APP_AI_ASSESSMENT_LISTING]: async (
    { commit }: { commit: Commit },
    payload: AppAssessmentListingPayload
  ): Promise<boolean> => {
    console.log("Action: APP_AI_ASSESSMENT_LISTING called", payload);
    try {
      const response = await fetch_app_ai_assessment_listing(payload);

      const data: AppAiAssessmentListing = {
        limit: payload.limit,
        page: payload.page,
        total: response.data.data.total,
        results: response.data.data.results,
        selected_dates: payload.selected_dates,
        selected_candidates: payload.selected_candidates,
        score_filter: payload.score_filter,
        status_filter: payload.status_filter
      };

      commit(APP_AI_ASSESSMENT_LISTING, data);
      return true;
    } catch (e) {
      console.error("Action: APP_AI_ASSESSMENT_LISTING error", e);
      return false;
    }
  },
  [FETCH_APP_AI_ASSESSMENT]: async (
    { commit }: { commit: Commit },
    payload: FetchAppAiAssessmentPayload
  ): Promise<boolean> => {
    try {
      const response = await fetch_app_ai_assessment(payload);
      commit(FETCH_APP_AI_ASSESSMENT, response.data.data);
      return response.data.data;
    } catch (e) {
      return false;
    }
  },
  [RESET_ASSESSMENT]: async (
    _: { commit: Commit },
    payload: ResetAssessmentPayload
  ): Promise<string | null> => {
    try {
      const response = await reset_assessment(payload);
      return response.data.data;
    } catch (e) {
      return null;
    }
  },
  [RESET_AI_ASSESSMENT]: async (
    _: { commit: Commit },
    payload: ResetAssessmentPayload
  ): Promise<string | null> => {
    try {
      const response = await reset_ai_assessment(
        payload.assessment_id,
        payload.user_id
      );
      return response.data.data;
    } catch (e) {
      return null;
    }
  },
  [RESET_CANCELLED_ASSESSMENT]: async (
    _: { commit: Commit },
    payload: DeleteCancelledAssessmentPayload
  ): Promise<string | null> => {
    try {
      const response = await reset_all_cancelled_assessment(payload);
      return response.data.data;
    } catch (e) {
      return null;
    }
  },
  [INCEPTION_STATS]: async ({
    commit
  }: {
    commit: Commit;
  }): Promise<string | null> => {
    try {
      const response = await inception_stats();
      commit(INCEPTION_STATS, response.data.data);
      return null;
    } catch (e) {
      return null;
    }
  },
  //
  [DASHBOARD_COUNTS]: async ({
    commit
  }: {
    commit: Commit;
  }): Promise<string | null> => {
    try {
      const response = await dashboard_counts();
      // console.log("response.data:", response.data.data);
      commit(DASHBOARD_COUNTS, response.data.data);
      return null;
    } catch (e) {
      console.log("API Error: ", e);
      return null;
    }
  },
  //
  [UPDATE_COMPANY_SETTING]: async (
    { commit }: { commit: Commit },
    payload: UpdateCompanySettingPayload
  ): Promise<Company | null> => {
    try {
      const resp = await update_company_setting(payload);
      return resp.data.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [UPDATE_APPROVAL_CRITERIA]: async (
    { commit }: { commit: Commit },
    payload: UpdateApprovalCriteriaPayload
  ): Promise<Company | null> => {
    try {
      const resp = await update_approval_criteria(payload);
      return resp.data.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [GET_EMAIL_TEMPLATES]: async ({
    commit
  }: {
    commit: Commit;
  }): Promise<boolean> => {
    try {
      const resp = await get_email_templates();
      commit(GET_EMAIL_TEMPLATES, resp.data.data);
      return true;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return false;
    }
  },
  [GET_SURVEY_QUESTIONS]: async ({
    commit
  }: {
    commit: Commit;
  }): Promise<boolean> => {
    try {
      const resp = await get_survey_questions();
      console.log(resp.data.data, "resp.data");
      commit(GET_SURVEY_QUESTIONS, resp.data.data);
      return true;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return false;
    }
  },
  [ADD_SURVEY_QUESTION]: async (
    { commit }: { commit: Commit },
    payload: AddSurveyQuestionPayload
  ): Promise<boolean | null> => {
    try {
      console.log("Action called");
      const resp = await add_survey_question(payload);
      console.log(resp.data.data[0], "resp.data.data");
      return true;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [UPDATE_SURVEY_QUESTION]: async (
    { commit }: { commit: Commit },
    { payload, id }: { payload: AddSurveyQuestionPayload; id: number }
  ): Promise<boolean | null> => {
    try {
      await update_survey_question(payload, id);
      return true;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [DELETE_SURVEY_QUESTION]: async (
    { commit }: { commit: Commit },
    { id }: { id: number }
  ): Promise<boolean | null> => {
    try {
      await delete_survey_question(id);
      return true;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [SUBMIT_SURVEY_QUESTIONS]: async (
    { commit }: { commit: Commit },
    payload: SubmitSurveyQuestionsPayload
  ): Promise<boolean | null> => {
    try {
      const resp = await submit_survey_questions(payload);
      console.log(resp.data.data[0], "resp.data.data");
      return true;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [FETCH_OVERALL_ASSESSMENTS]: async (
    { commit }: { commit: Commit },
    payload: AppOverAllAssessmentListing
  ): Promise<boolean | string> => {
    try {
      const response = await fetch_app_overall_result(payload);

      if (payload.download_report) {
        // Backend returns JSON { data: reportUrl }; return URL so caller can set window location
        // (window.open after await is blocked by popup blockers)
        const reportUrl = response.data?.data;
        return typeof reportUrl === "string" ? reportUrl : "";
      }

      // Backend already filters by pass/fail using SQL query
      // No need for additional client-side filtering
      const filteredResults = response.data.data.results;

      const data: AppOverAllAssessmentListing = {
        limit: payload.limit,
        page: payload.page,
        total: response.data.data.total,
        selected_dates: payload.selected_dates,
        selected_candidates: payload.selected_candidates,
        score_filter: payload.score_filter,
        results: filteredResults,
        average_score_filter: payload.average_score_filter,
        assessment_versions: payload.assessment_versions,
        english_assessment_filter: payload.english_assessment_filter,
        annotation_assessment_filter: payload.annotation_assessment_filter,
        eid_name_filter: payload.eid_name_filter
      };
      commit(FETCH_OVERALL_ASSESSMENTS, data);
      return true;
    } catch (e) {
      console.error("❌ Frontend: Error fetching overall assessments:", e);
      return false;
    }
  },
  [FETCH_CANCELLED_ASSESSMENTS_CANDIDATES]: async (
    { commit }: { commit: Commit },
    payload: FetchCancelledAssessmentCandidatesPayload
  ): Promise<boolean | string> => {
    try {
      const response = await fetch_cancelled_assessment_candidates(payload);
      const data: CancelledAssessmentCandidates = {
        limit: payload.limit,
        page: payload.page,
        total: response.data.data.total,
        results: response.data.data.results,
        assessment_version: payload.assessment_version,
        user_ids: payload.user_ids
      };
      commit(FETCH_CANCELLED_ASSESSMENTS_CANDIDATES, data);
      return true;
    } catch (e) {
      return false;
    }
  },
  [FETCH_REDO_ASSESSMENTS_CANDIDATES]: async (
    { commit }: { commit: Commit },
    payload: FetchRedoAssessmentCandidatesPayload
  ): Promise<boolean | string> => {
    try {
      const response = await fetch_redo_assessment_candidates(payload);
      const data: RedoAssessmentCandidates = {
        limit: payload.limit,
        page: payload.page,
        total: response.data.data.total,
        results: response.data.data.results,
        assessment_version: payload.assessment_version,
        user_ids: payload.user_ids
      };
      // console.log(data, "====================data");
      commit(FETCH_REDO_ASSESSMENTS_CANDIDATES, { ...data });
      return true;
    } catch (e) {
      return false;
    }
  },
  [REDO_ASSESSMENT_REQUEST]: async (
    _: { commit: Commit },
    assessment_id: number
  ): Promise<boolean | string> => {
    try {
      await redo_assessment_request(assessment_id);
      return true;
    } catch (e) {
      return false;
    }
  },
  [APPROVE_ASSESSMENT_RESUME]: async (
    _: { commit: Commit },
    result_id: number
  ): Promise<boolean> => {
    try {
      await approve_assessment_resume(result_id);
      return true;
    } catch (_e) {
      return false;
    }
  },
  [REJECT_ASSESSMENT_RESUME]: async (
    _: { commit: Commit },
    result_id: number
  ): Promise<boolean> => {
    try {
      await reject_assessment_resume(result_id);
      return true;
    } catch (_e) {
      return false;
    }
  },
  [GET_EMAIL_TEMPLATE]: async (
    { commit }: { commit: Commit },
    template_id: number
  ): Promise<EmailTemplate | null> => {
    try {
      const resp = await get_email_template(template_id);
      console.log(resp.data[0], "resp.data.data");
      return resp.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [UPDATE_EMAIL_TEMPLATE]: async (
    { commit }: { commit: Commit },
    payload: UpdateEmailTemplatePayload
  ): Promise<boolean | null> => {
    try {
      const resp = await update_email_template(payload);
      console.log(resp.data.data[0], "resp.data.data");
      return true;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [FETCH_AI_ASSESSMENT_LISTING]: async (
    { commit }: { commit: Commit },
    payload: FetchAssessmentAiListingPayload
  ): Promise<{ data: AssessmentAiListing } | null> => {
    try {
      const resp = await fetch_ai_assessment_listing(payload);
      commit(FETCH_AI_ASSESSMENT_LISTING, resp.data.assessments);
      return resp.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [DELETE_AI_ASSESSMENT]: async (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    { commit, rootGetters }: { commit: Commit; rootGetters: any },
    assessmentId: number
  ): Promise<boolean> => {
    try {
      //Get current user from auth state
      const currentUser = rootGetters["auth/GET_USER_DETAILS"];
      const userId = currentUser?.id;
      await delete_assessment({ assessment_id: assessmentId, user_id: userId }); // TODO: Get actual user_id
      commit(DELETE_AI_ASSESSMENT, assessmentId);
      return true;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return false;
    }
  },
  [FETCH_AI_ASSESSMENT_DETAILS]: async (
    { commit }: { commit: Commit },
    assessmentId: number
  ): Promise<unknown | null> => {
    try {
      const resp = await fetch_ai_assessment_details(assessmentId);
      return resp.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [UPDATE_AI_ASSESSMENT]: async (
    { commit }: { commit: Commit },
    payload: {
      id: number;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [key: string]: any;
    }
  ): Promise<boolean> => {
    try {
      await update_ai_assessment(payload);
      return true;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return false;
    }
  },
  [FETCH_ASSESSMENT_STATS]: async ({
    commit
  }: {
    commit: Commit;
  }): Promise<AssessmentStats | null> => {
    try {
      const stats = await fetch_assessment_stats();

      commit(FETCH_ASSESSMENT_STATS, stats);
      return stats;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [FETCH_AI_ASSESSMENT_QUESTIONS]: async (
    { commit }: { commit: Commit },
    payload: { assessmentId: number; query: FetchAssessmentAiQuestionsPayload }
  ): Promise<{
    questions: AssessmentQuestions.Questions[];
    page: number;
    limit: number;
  } | null> => {
    try {
      const resp = await fetch_ai_assessment_questions(
        payload.assessmentId,
        payload.query
      );
      return resp.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [ADD_AI_ASSESSMENT_QUESTION]: async (
    { commit }: { commit: Commit },
    payload: { assessmentId: number; questions: AssessmentQuestion[] }
  ): Promise<AssessmentQuestion[] | null> => {
    try {
      const response = await add_ai_assessment_question(payload.assessmentId, {
        questions: payload.questions
      });
      commit(ROOT_NOTIFICATION, "Question added successfully", {
        root: true
      });
      return response.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [UPDATE_AI_ASSESSMENT_QUESTION]: async (
    { commit }: { commit: Commit },
    payload: {
      assessmentId: number;
      questionId: number;
      question: AssessmentQuestion;
    }
  ): Promise<AssessmentQuestion | null> => {
    try {
      const response = await update_ai_assessment_question(
        payload.assessmentId,
        payload.questionId,
        payload.question
      );
      commit(ROOT_NOTIFICATION, "Question updated successfully", {
        root: true
      });
      return response.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [DELETE_AI_ASSESSMENT_QUESTION]: async (
    { commit }: { commit: Commit },
    payload: { assessmentId: number; questionId: number }
  ): Promise<boolean> => {
    try {
      await delete_ai_assessment_question(
        payload.assessmentId,
        payload.questionId
      );
      commit(ROOT_NOTIFICATION, "Question deleted successfully", {
        root: true
      });
      return true;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return false;
    }
  },
  [CREATE_AI_ASSESSMENT_SESSION]: async (
    { commit }: { commit: Commit },
    payload: {
      id: number;
      assessment_type: string;
      assessment_name: string;
      difficulty: string;
      is_active: boolean;
      created_at: string;
      total_questions: string;
      questions: unknown[];
    }
  ): Promise<{ session_id: string; message: string } | null> => {
    try {
      commit(CLEAR_AI_SESSION);
      const response = await create_ai_assessment_session(payload);
      if (response.data) {
        // Save session data to store
        commit(SET_AI_SESSION, {
          session_id: response.data.session_id,
          session_message: response.data?.message
        });
      }
      return response.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [CHAT_WITH_AI_ASSISTANT]: async (
    { commit }: { commit: Commit },
    payload: {
      session_id: string;
      message: string;
    }
  ): Promise<{
    session_id: string;
    status: string;
    message: string;
    current_step: string;
    assessment_data: {
      questions: unknown[];
    };
  } | null> => {
    try {
      const response = await chat_with_ai_assistant(payload);
      return response.data;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return null;
    }
  },
  [UPDATE_ASSESSMENT_WITH_AI]: async (
    { commit }: { commit: Commit },
    payload: {
      assessment_id: number;
      assessment_name: string;
      assessment_type: string;
      difficulty: string;
      is_active: boolean;
      questions: AssessmentQuestion[];
      deleted_question_ids: number[];
    }
  ): Promise<boolean> => {
    try {
      await update_assessment_with_ai(payload.assessment_id, {
        assessment_name: payload.assessment_name,
        assessment_type: payload.assessment_type,
        difficulty: payload.difficulty,
        is_active: payload.is_active,
        questions: payload.questions,
        deleted_question_ids: payload.deleted_question_ids
      });
      commit(ROOT_NOTIFICATION, "Assessment updated with AI assistance", {
        root: true
      });
      return true;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return false;
    }
  },
  [FETCH_AVAILABLE_APPLICANTS]: async ({
    commit
  }: {
    commit: Commit;
  }): Promise<boolean> => {
    try {
      const response = await fetch_available_applicants();
      commit(SET_AVAILABLE_APPLICANTS, response.data.data || response.data);
      return true;
    } catch (e) {
      commit(ROOT_ERROR, "Failed to load available applicants", {
        root: true
      });
      return false;
    }
  },
  [ASSIGN_ASSESSMENT_TO_APPLICANTS]: async (
    { commit, getters }: { commit: Commit; getters: unknown },
    payload: { assessment_id: number; applicant_ids?: string[] }
  ): Promise<boolean> => {
    try {
      let applicant_ids = payload.applicant_ids;

      if (!applicant_ids || applicant_ids.length === 0) {
        const typedGetters = getters as {
          SELECTED_APPLICANTS: { label: string; value: string }[];
        };
        const selected = typedGetters.SELECTED_APPLICANTS || [];

        if (!selected || selected.length === 0) return false;
        applicant_ids = selected.map((a: { value: string }) => a.value);
      }

      if (!applicant_ids) return false;

      console.log("applicant_ids", applicant_ids);
      await assign_assessment_to_applicant({
        assessment_id: payload.assessment_id,
        applicant_ids: applicant_ids
      });
      return true;
    } catch (e) {
      commit(ROOT_ERROR, e, { root: true });
      return false;
    }
  },
  [FETCH_APPLICANT_ASSESSMENTS]: async (
    { commit }: { commit: Commit },
    payload:
      | string
      | { applicant_id: string; params?: { page?: number; limit?: number } }
  ): Promise<boolean> => {
    try {
      let applicant_id: string;
      let params: { page?: number; limit?: number } | undefined;

      // Handle both old format (just applicant_id string) and new format (object with params)
      if (typeof payload === "string") {
        applicant_id = payload;
        params = undefined;
      } else {
        applicant_id = payload.applicant_id;
        params = payload.params;
      }

      const response = await fetch_applicant_assessments(applicant_id, params);

      // Handle both paginated and non-paginated responses
      const responseData = response.data.data;
      if (responseData.pagination) {
        // Paginated response with new structure
        commit(SET_APPLICANT_ASSESSMENTS, {
          data: responseData.assessments || [],
          total: responseData.pagination.total_count || 0,
          page: responseData.pagination.current_page || 1,
          limit: responseData.pagination.per_page || 10,
          totalPages: responseData.pagination.total_pages || 1
        });
      } else if (responseData.assessments) {
        // Paginated response with old structure
        commit(SET_APPLICANT_ASSESSMENTS, {
          data: responseData.assessments || [],
          total: responseData.total || 0,
          page: responseData.page || 1,
          limit: responseData.limit || 10
        });
      } else {
        // Non-paginated response (backward compatibility)
        commit(SET_APPLICANT_ASSESSMENTS, responseData || []);
      }

      return true;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      // Only show error if it's not a 404 (not found) or expected empty state
      // Silently handle cases where applicant has no assessments yet
      const status = e?.response?.status;
      if (status !== 404 && status !== 200) {
        // Only show error for actual server errors, not expected empty states
        console.warn("Failed to load applicant assessments:", e);
        // Don't show error notification to user - this is expected in many cases
      }
      // Return empty array structure for consistency
      commit(SET_APPLICANT_ASSESSMENTS, {
        data: [],
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0
      });
      return false;
    }
  },
  [FETCH_APPLICANT_ASSESSMENT_DETAILS]: async (
    { commit }: { commit: Commit },
    payload: { applicant_id: string; assessment_id: string }
  ): Promise<boolean> => {
    try {
      const response = await fetch_applicant_assessment_details(
        payload.applicant_id,
        payload.assessment_id
      );
      commit(
        SET_APPLICANT_ASSESSMENT_DETAILS,
        response.data.data || response.data
      );
      return true;
    } catch (e) {
      commit(ROOT_ERROR, "Failed to load assessment details", {
        root: true
      });
      return false;
    }
  }
};
